import { applyMiddleware, createStore, AnyAction, Middleware } from "redux";

import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { composeWithDevTools } from "@redux-devtools/extension";

import rootReducer, { IStoreState } from "./rootReducer";
import { withExtraArgument, ThunkDispatch, ThunkAction } from "redux-thunk";

import { IGcpAppIo } from "./io";

import { loggerMiddleware } from "./modules/logger";
import { hotKeyMiddleware } from "./modules/hotkeys/hotkeyMiddleware";

// we will mock this in tests
export type IExtraArgument = IGcpAppIo;

export type IGcpAppDispatch = ThunkDispatch<
  IStoreState,
  IExtraArgument,
  AnyAction
>;

export interface IGcpAppDispatchProp {
  dispatch: IGcpAppDispatch;
}
export type IGcpAppAction =
  | ThunkAction<any, IStoreState, IExtraArgument, AnyAction>
  | IAction<any>;
export type IGcpAppStore = any;

const composeEnhancers = composeWithDevTools({ trace: true, traceLimit: 25 });

export const createGcpAppStoreWithoutSaga = (
  io: IGcpAppIo,
  middlewares: Middleware[] = [],
): IGcpAppStore => {
  return createStore(
    rootReducer,
    composeEnhancers(
      applyMiddleware(
        ...middlewares,
        withExtraArgument(io),
        loggerMiddleware,
        hotKeyMiddleware,
      ),
    ),
  );
};

// typed hooks
export const useAppDispatch = () => useDispatch<IGcpAppDispatch>();
export const useAppSelector: TypedUseSelectorHook<IGcpAppStore> = useSelector;
